import script from "./HiddenTokensPills.vue?vue&type=script&setup=true&lang=ts"
export * from "./HiddenTokensPills.vue?vue&type=script&setup=true&lang=ts"

import "./HiddenTokensPills.vue?vue&type=style&index=0&id=9d791430&scoped=true&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d791430"]])

export default __exports__